const INVALID_VALUES = new Set(['', '-', '--', 'n/a', 'na', 'null', 'undefined']);

const cleanText = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  if (!text) return '';
  return INVALID_VALUES.has(text.toLowerCase()) ? '' : text;
};

const pickFirstValid = (values = []) => {
  for (let i = 0; i < values.length; i += 1) {
    const text = cleanText(values[i]);
    if (text) return text;
  }
  return '';
};

export const getDisplayName = (source, fallback = 'Unknown User') => {
  if (!source) return fallback;
  if (typeof source === 'string') return cleanText(source) || fallback;

  const nestedUser = source.user || source.createdBy || source.author || source.responder;

  const value = pickFirstValid([
    source.userName,
    source.username,
    source.name,
    source.displayName,
    source.createdByName,
    source.respondedByName,
    source.commentByName,
    nestedUser?.userName,
    nestedUser?.username,
    nestedUser?.name,
    nestedUser?.displayName,
    source.email,
    nestedUser?.email,
  ]);

  return value || fallback;
};

export const getRoleLabel = (source, fallback = '') => {
  if (!source) return fallback;
  if (typeof source === 'string') return cleanText(source) || fallback;

  const nestedUser = source.user || source.createdBy || source.author || source.responder;
  const value = pickFirstValid([
    source.userRole,
    source.role,
    source.usertype,
    source.createdByRole,
    nestedUser?.userRole,
    nestedUser?.role,
    nestedUser?.usertype,
  ]);

  return value || fallback;
};

export const getTicketCreatorName = (ticket) => getDisplayName(ticket, 'Unknown Reporter');

export const getCommentAuthorName = (comment) => getDisplayName(comment, 'Support');

export const getCommentAuthorRole = (comment) => getRoleLabel(comment, '');
